import { httpClient } from '../lib/httpClient';
import type { DocumentRequest, DocumentRequestUrgency } from '../types/complianceWorkflow';

export async function createDocumentRequest(data: { client_id: string; document_type: string; reason: string; urgency: DocumentRequestUrgency; deadline?: string }) {
  return httpClient.post<DocumentRequest>('/api/document-requests', data);
}

export async function getDocumentRequests(clientId: string) {
  // TASK-655 gate finding (root cause of the audit's "requests.map is not a
  // function"): the endpoint returns an envelope {total, requests: []}, not a
  // bare array. Unwrap and validate here — every consumer gets a real array.
  const data = await httpClient.get<{ total: number; requests: DocumentRequest[] } | DocumentRequest[]>(
    '/api/document-requests',
    { params: { client_id: clientId } },
  );
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.requests) ? data.requests : [];
}

export async function getDocumentRequest(id: string) {
  return httpClient.get<DocumentRequest>(`/api/document-requests/${id}`);
}

export async function cancelDocumentRequest(id: string) {
  return httpClient.put(`/api/document-requests/${id}/cancel`);
}
